<template src="./html/Edit.html"></template>

<script>
	import swal from 'sweetalert2'
	import VueElementLoading from 'vue-element-loading'

	export default {
		props: ['user', 'isAuth'],
		components: {
			'loading': VueElementLoading,
		},
		data () {
			return {
				modal: {
					selector: 'modal-edit-product-attribute-' + new Date().getTime(),
				},
				loading: false,
				types: null,
				item: null,
			}
		},
		methods: {
			open(item) {
				this.item = null
				if(item) {
					this.item = JSON.parse(JSON.stringify(item))
				}
				this.clearData()
				this.init()
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
			},
			close() {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			init() {
				this.getTypes()
			},
			clearData() {
				this.errors.clear()
			},
			getTypes() {
				this.loading = true
				this.$http.get('admin/management/products/attribute/type/fields')
				.then(response => {
					this.types = response.body
					this.loading = false
				})
			},
			validate(event) {
				var that = this
				return this.$validator.validateAll().then((result) => {
					if(result) {
						that.update()
					}
					return result
				})
			},
			update () {
				this.loading = true
				this.$http.put('admin/management/products/attribute/lists/' + this.item.id, this.item)
				.then(response => {
					this.close()
					this.$emit('reload')
					this.$emit('openEdit', response.body.data)
					this.clearData()
					swal({
						title: response.body.title,
						text: response.body.text,
						type: response.body.type,
					})
					this.loading = false
				}).catch(function(response) {
					console.log(response)
					this.loading = false
					this.clearData()
					this.$emit('reload')
				})
			},
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/management/productAttributeLists/views/Edit.vue